import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { FieldGallery } from "@/components/FieldGallery";
import { Practice } from "@/components/Practice";
import { Capabilities } from "@/components/Capabilities";
import { Background } from "@/components/Background";
import { ServiceRadius } from "@/components/ServiceRadius";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="bg-slate-ground text-stone-900 antialiased min-h-screen" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <FieldGallery />
        <Practice />
        <Capabilities />
        <Background />
        <ServiceRadius />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
